import Svg, { ClipPath, Defs, G, Path, Rect } from "react-native-svg";
const ArrowRightIcon = (props) => (
    <Svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <G clip-path="url(#clip0_7657_2761)">
            <Path d="M2.5 9.16667H14.3083L11.325 6.175L12.5 5L17.5 10L12.5 15L11.325 13.825L14.3083 10.8333H2.5V9.16667Z" fill="#6724E2" />
        </G>
        <Defs>
            <ClipPath id="clip0_7657_2761">
                <Rect width="20" height="20" fill="white" transform="matrix(-1 0 0 1 20 0)" />
            </ClipPath>
        </Defs>
    </Svg>

);
export default ArrowRightIcon;
